import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ServiceTypeModel } from './model';

export const serviceTypeAdapter: EntityAdapter<ServiceTypeModel> = createEntityAdapter<ServiceTypeModel>({
  selectId: model => model.id,
  sortComparer: (a: ServiceTypeModel, b: ServiceTypeModel): number => a.sortOrder - b.sortOrder,
});

export interface ServiceTypeState extends EntityState<ServiceTypeModel> {
  isLoading?: boolean;
  error?: any;
}

export const initialState: ServiceTypeState = serviceTypeAdapter.getInitialState({
  isLoading: false,
  error: null,
});
